import { redirectPageName } from "../utils/helpers";

export default function guest({ next, store }) {
  if (store.getters["auth/loggedIn"]) {
    return next({
      name: redirectPageName(),
    });
  }

  return next();
}
